import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5 12h14",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12 5v14",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	})]
});
export default SvgPlus;
